import {ReadOnlyTextController} from './controllers/readOnlyTextController';

import './styles/readOnlyText.css'

export class ReadOnlyTextDirective implements angular.IDirective {
    restrict = 'E';
    controller = ReadOnlyTextController;
    controllerAs = 'vm';
    template = require('./templates/readOnlyText.html');
    replace = true;
    bindToController = {
        value: '=',
        defaultValue: '@',
        placeholder: '@',
        isNumber: '@',
        numberOfDecimalPlaces: '@',
        removeMargin: '@',
        isDisabled: '<'
    };
    scope = {};

    link = (scope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {

        if (!attrs.$attr['value'] || !attrs.$attr['value'].trim().length)
            console.error('value property on read-only-text directive is required.');
    };

    static factory(): angular.IDirectiveFactory {
        return () => new ReadOnlyTextDirective();
    }
}

angular.module('deliveryCreate.app').directive('readOnlyText', ReadOnlyTextDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/readOnlyText/readOnlyTextDirective.ts
 **/